import React from 'react';
import { Link, BrowserRouter } from "react-router-dom";
import { styled } from '@mui/system';
import Tile from './Tile.js';
import concatTokens from '../../services/concatTokens.js';
import StepTile from './StepTile.js';

/**
 *
 * @param {*} param0
 */
const Tiles = ({
  tiles,
  stepped,
  children,
  customStyle,
  classes,
  id,
  testid
}) => {
  const Container = styled('div')({
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 auto'
  });
  return /*#__PURE__*/React.createElement(Container, {
    id: id || testid,
    style: customStyle
  }, children, tiles.map(tile => /*#__PURE__*/React.createElement(Link, {
    key: concatTokens(tile.title, tile.description),
    to: tile.link || '',
    onClick: !tile.link ? e => {
      e.preventDefault();
      if (tile.disabled) {
        return;
      }
      tile.onClick();
    } : null,
    style: {
      width: '50%',
      padding: "5px 8px",
      textDecoration: 'none',
      zIndex: 2
    }
  }, stepped ? /*#__PURE__*/React.createElement(StepTile, {
    id: tile.id || tile.testid,
    title: tile.title,
    description: tile.description,
    step: tile.step,
    disabled: tile.disabled,
    tooltip: tile.tooltip,
    completed: tile.completed,
    icon: tile.icon
  }) : /*#__PURE__*/React.createElement(Tile, {
    id: tile.id || tile.testid,
    title: tile.title,
    description: tile.description,
    icon: tile.icon,
    isSelected: tile.isSelected,
    step: tile.step,
    disabled: tile.disabled,
    tooltip: tile.tooltip,
    subtitle: tile.subtitle
  }))));
};
export default Tiles;